var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.blockItems)?_c('div',[_c(_vm.blockType,{tag:"component",attrs:{"slug":_vm.block.slug,"queryBlockItems":_vm.queryBlockItems,"simpleBlockItems":_vm.simpleBlockItems,"details":_vm.block,"startBgColor":_vm.startBgColor,"isMobileApp":_vm.isMobileApp}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }